'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormLabel = require('./FormLabel');

Object.defineProperty(exports, 'FormLabel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormLabel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/formLabel/index.js
// module id = 135
// module chunks = 0